import React from 'react';
import { Button, Grid, Card, CardActions, CardMedia, CardContent, Typography } from '@mui/material';
import _ from 'lodash';
import classnames from 'classnames';

export class FulfilmentTypeOption extends React.Component {
  render() {
    const { option, classes, handleNext, optionSelected } = this.props;
    var isActive = optionSelected ? 'active' : '';

    return (
      <React.Fragment>
        <Grid container spacing={3} justifyContent="center">
          <Grid size={{md: 8, sm: 8, xs: 12}}>
            <Card className={classnames('fulfilment-type-card', isActive)}>
               {option.gift_image &&
                 <CardMedia className="gift-image" image={option.gift_image} style={{height: 140}} />
               }
              <CardContent>
                <Typography align="center" gutterBottom variant="h5">{option.name}</Typography>
                <Typography component="p">{option.description}</Typography>
              </CardContent>
              <CardActions style={{justifyContent: 'center'}}>
                <Button variant="contained" color="primary" value={option.id} onClick={() => handleNext(option.id)}>Select</Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </React.Fragment>
    )
  }
}

export default FulfilmentTypeOption;
